import { render, staticRenderFns } from "./subcontractingRegional.vue?vue&type=template&id=33a90636&scoped=true&"
import script from "./subcontractingRegional.vue?vue&type=script&lang=js&"
export * from "./subcontractingRegional.vue?vue&type=script&lang=js&"
import style0 from "./subcontractingRegional.vue?vue&type=style&index=0&id=33a90636&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a90636",
  null
  
)

export default component.exports